import { useRef, useCallback } from "react";
export const useMinimumLoadingTime = (minLoadTime = 500) => {
  const loadStartTimeRef = useRef(null);

  const startLoading = useCallback(() => {
    loadStartTimeRef.current = Date.now();
  }, []);

  const finishLoading = useCallback(
    callback => {
      if (!loadStartTimeRef.current) {
        callback();
        return;
      }

      const elapsedTime = Date.now() - loadStartTimeRef.current;
      const remainingTime = Math.max(0, minLoadTime - elapsedTime);

      setTimeout(() => {
        callback();
        loadStartTimeRef.current = null;
      }, remainingTime);
    },
    [minLoadTime]
  );

  return { startLoading, finishLoading };
};
